import '../assets/css/style.css';
import { renderEndServices, hideMarkOverFooter } from '../assets/js/footer.js';

renderEndServices();
hideMarkOverFooter();
